export default __webpack_public_path__ + "static/media/cruzRoja.2aea5bfd.jpg";